/* @flow */
import * as React from 'react';

const Checkmark = props => (
  <svg width={80} height={80} viewBox="0 0 80 80" fill="#3B4478" fillRule="evenodd" {...props}>
    <defs>
      <circle id="path-1" cx="40" cy="40" r="40" />
      <mask
        id="mask-2"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="80"
        height="80"
        fill="white">
        <use xlinkHref="#path-1" />
      </mask>
    </defs>
    <g id="desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="become-a-lugger" transform="translate(-1235.000000, -2056.000000)" fill="#3B4478">
        <g id="helper-step-1-copy" transform="translate(1070.000000, 1840.000000)">
          <g id="Group-5" transform="translate(24.000000, 216.000000)">
            <g id="lugger_form_check" transform="translate(141.000000, 0.000000)">
              <use
                id="Oval-3"
                stroke="#2E3667"
                mask="url(#mask-2)"
                strokeWidth="4"
                fillOpacity="0"
                opacity="0.2"
                xlinkHref="#path-1"
              />
              <path
                d="M33.7559582,51.2992614 C34.2016703,51.7672204 34.7845247,52 35.3696648,52 C35.9548049,52 36.5376593,51.7672204 36.9833714,51.2992614 L55.3284274,32.1009433 C56.2221374,31.1650253 56.2267088,29.6459584 55.3329988,28.7052408 C54.4415744,27.766923 52.9970098,27.7645232 52.1010141,28.7004412 L35.3696648,46.2093073 L27.8999859,38.3931921 C27.0039902,37.4596738 25.5617113,37.4620736 24.6680012,38.3979916 C23.7742912,39.3363094 23.7788626,40.8553764 24.6725726,41.7936942 L33.7559582,51.2992614 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Checkmark;



// WEBPACK FOOTER //
// ./src/assets/images/icons/checkmark.js